export default __webpack_public_path__ + "static/media/exclusivAlu.4e3b7f34.jpg";